import styled from "styled-components";

interface BannerCarouselContainerProps {
  slideDuration: number;
}

export const BannerCarouserContainer = styled.section<BannerCarouselContainerProps>`
  width: 100%;
  display: flex;

  .swiper-button-next, .swiper-button-prev {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    transition: background 0.1s ease;
  }
  
  .swiper-button-next:hover, .swiper-button-prev:hover {
    background: rgba(0,0,0,0.2);
  }

  .swiper-pagination {
    width: 200px !important;
    display: flex;
    left: 50% !important;
    transform: translate(-50%);
    justify-content: center;
  }

  span.swiper-pagination-bullet {
    width: 100%;
    max-width: 60px;
    border-radius: 16px;
    background: rgba(255,255,255,.5);
    position: relative;
    overflow: hidden;
    opacity: 1;
  }
  
  span.swiper-pagination-bullet.swiper-pagination-bullet-active .slide-progress {
    background: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0; 
    left: 0;
    opacity: 1;
    animation: ${({ slideDuration }) => slideDuration}ms linear bullet-progress;
  }

  @keyframes bullet-progress {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

`

